import './PersonDetails.scss';

import stepBlockIcon from 'assets/images/icons/step-block-icon.svg';

import { Chip } from '../../components/Chip/Chip';
import { Tabs } from '../../components/Tabs/Tabs';

import { GetPersonDetailsTabs } from './PersonDetailsTabs';
import usePersonDetailsPageVM from './usePersonDetailsPageVM';
import { Loader } from 'components/Loader/Loader';
import { statusMap } from 'utils/enumFormatter';
import { Button } from 'components/Button/Button';
import { MdEdit, MdAdd, MdDelete } from 'react-icons/md';
import { Modal } from 'components/Modal/Modal';
import { Formik } from 'formik';
import Select from 'react-select';
import { DataList } from '../SettingsPage/SettingsTabs/DataList/DataList';
import { Datalist } from 'components/Datalist/Datalist';
import TipTap from 'components/TipTap/TipTap';

export function PersonDetails() {
    const {
        person,
        setPerson,
        isGetPersonDetailsLoading,
        personDetailsError,
        isProjectModalOpen,
        setIsProjectModalOpen,
        projectModalMode,
        setProjectModalMode,
        handleCreateProject,
        handleUpdateProject,
        handleUpdatePersonStatus,
        isOutgoingModalOpen,
        setIsDeleteModalOpen,
        isDeleteModalOpen,
        setIsOutgoingModalOpen,
        handleUpdateOutgoing,
        isUpdateOutgoingLoading,
        handleDeletePerson,
        userRole,
        handleSendAccessLink
    } = usePersonDetailsPageVM();

    if (isGetPersonDetailsLoading || !person || isUpdateOutgoingLoading) {
        return (
            <main id="person-folder">
                <Loader />
            </main>
        );
    }

    if (personDetailsError) {
        return (
            <main id="person-folder">
                <h2>Erreur lors du chargement de la personne. Veuillez recharger la page</h2>
            </main>
        );
    }

    if (Object.keys(person).length === 0) {
        return (
            <main id="person-folder">
                <h2>Personne non enregistrée</h2>
            </main>
        );
    }

    return (
        <>
            <main id="person-folder">
                <h2 className="title">
                    <Chip color={person.is_outgoing ? 'danger' : 'primary'} className="project-highlight">
                        <span>
                            <b>{person.is_outgoing ? 'Sortie' : statusMap[person.status]?.label || 'Statut inconnu'}</b>
                        </span>
                    </Chip>
                    <b>
                        Personne soutenue : <span className="person-name">{person.fullname}</span>
                    </b>
                    {person.email && person.email !== '' && (
                        <Button
                            label="Envoyer un lien d'accès"
                            variant="light"
                            onClick={() => {
                                handleSendAccessLink(person.id);
                            }}
                        />
                    )}
                </h2>

                <div className="project-state">
                    <div className="project-state-left">
                        {(userRole === 'manager' || userRole === 'admin') && (
                            <Button
                                variant="danger"
                                className="project-state-button"
                                icon={<MdDelete />}
                                iconAfter={true}
                                onClick={() => {
                                    setIsDeleteModalOpen(true);
                                }}
                            />
                        )}
                        <Chip color="lilas" className="project-highlight">
                            <img src={stepBlockIcon} alt="" />
                            <span>
                                {person.projects?.length > 0 ? (
                                    <>
                                        <b>Projet de vie</b> : {person.projects?.[0]?.label}
                                    </>
                                ) : (
                                    <b>Aucun projet de vie enregistré</b>
                                )}
                            </span>
                        </Chip>
                        {person.projects?.length > 0 ? (
                            <Button
                                variant="purple"
                                className="project-state-button"
                                icon={<MdEdit />}
                                iconAfter={true}
                                onClick={() => {
                                    setIsProjectModalOpen(true);
                                    setProjectModalMode('update');
                                }}
                            />
                        ) : (
                            <Button
                                variant="purple"
                                className="project-state-button"
                                icon={<MdAdd />}
                                iconAfter={true}
                                onClick={() => {
                                    setIsProjectModalOpen(true);
                                }}
                            />
                        )}
                    </div>
                    {/* <Select
                        options={
                            person.status === 'outgoing'
                                ? [
                                      {
                                          value: 'outgoing',
                                          label: statusMap['outgoing'].label,
                                          color: statusMap['outgoing'].color
                                      },
                                      {
                                          value: 'active',
                                          label: statusMap['active'].label,
                                          color: statusMap['active'].color
                                      }
                                  ]
                                : [
                                      {
                                          value: person.status,
                                          label: statusMap[person.status]?.label || 'Statut inconnu',
                                          color: statusMap[person.status]?.color || 'gray'
                                      },
                                      {
                                          value: 'outgoing',
                                          label: statusMap['outgoing'].label,
                                          color: statusMap['outgoing'].color
                                      }
                                  ]
                        }
                        value={
                            person.status && statusMap[person.status]
                                ? {
                                      value: person.status,
                                      label: statusMap[person.status].label,
                                      color: statusMap[person.status].color
                                  }
                                : {
                                      value: 'outgoing',
                                      label: statusMap['outgoing'].label,
                                      color: statusMap['outgoing'].color
                                  }
                        }
                        onChange={(newValue: any) => {
                            handleUpdatePersonStatus(newValue.value);
                        }}
                        className={`status-${(person.status && statusMap[person.status]?.color) || 'waiting'}`}
                    /> */}
                    <Button
                        label={person.is_outgoing ? 'Réaffecter au dispositif' : 'Sortir du dispositif'}
                        variant="light"
                        onClick={() => {
                            setIsOutgoingModalOpen(true);
                        }}
                    />
                </div>
                <Tabs
                    tabs={GetPersonDetailsTabs(person, setPerson)}
                    linkPrefix={`admin/persons/`}
                    params={{
                        personId: person.id,
                        projectId: person.projects?.[0]?.id ?? null
                    }}
                    errorMessage="Veuillez ajouter un projet de vie à cette personne afin de pouvoir accéder à cette section"
                />
            </main>

            <Modal
                open={isDeleteModalOpen}
                yesText={'Oui'}
                title={'Supprimer cette personne soutenue ?'}
                onValidate={() => {
                    document.getElementById('deleteForm')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }}
                noText="Non"
                onClose={() => setIsDeleteModalOpen(false)}
                setClose={() => setIsDeleteModalOpen(false)}
            >
                <>
                    <p>Attention, cette action est irréversible.</p>
                    <Formik
                        initialValues={{}}
                        onSubmit={async (values, { setSubmitting }) => {
                            handleDeletePerson(person.id);
                        }}
                    >
                        {(props) => <form id="deleteForm" onSubmit={props.handleSubmit} noValidate></form>}
                    </Formik>
                </>
            </Modal>
            <Modal
                open={isProjectModalOpen}
                yesText={projectModalMode === 'create' ? 'Créer' : 'Mettre à jour'}
                onValidate={() => {
                    document.getElementById('projectForm')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }}
                noText="Annuler"
                onClose={() => setIsProjectModalOpen(false)}
                setClose={() => setIsProjectModalOpen(false)}
                className="update-project-modal"
            >
                <Formik
                    initialValues={{
                        label: person.projects?.[0]?.label || '',
                        initial_request: person.projects?.[0]?.initial_request || ''
                    }}
                    enableReinitialize={true}
                    onSubmit={async (values, { setSubmitting }) => {
                        if (projectModalMode === 'create') {
                            handleCreateProject({
                                id: person.id,
                                label: values.label,
                                initial_request: values.initial_request
                            });
                        } else if (projectModalMode === 'update' && person) {
                            handleUpdateProject({
                                id: person.id,
                                project_id: person.projects?.[0]?.id || 0,
                                label: values.label,
                                initial_request: values.initial_request
                            });
                        }
                        setSubmitting(false);
                    }}
                >
                    {(props) => (
                        <form id="projectForm" onSubmit={props.handleSubmit} noValidate>
                            <div className="form">
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Intitulé du projet</label>
                                        <input
                                            type="text"
                                            name="label"
                                            placeholder="Intitulé du projet"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.label}
                                        />
                                        {props.errors.label && props.touched.label && <p className="error">{String(props.errors.label)}</p>}
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Demande initiale du projet</label>
                                        {/* <textarea
                                            name="initial_request"
                                            placeholder="Demande initiale"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.initial_request}
                                            rows={5}
                                        /> */}
                                        <div className="wysiwyg-container">
                                            <TipTap
                                                name="initial_request"
                                                value={props.values.initial_request}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                            />
                                        </div>
                                        {props.errors.initial_request && props.touched.initial_request && (
                                            <p className="error">{String(props.errors.initial_request)}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </Modal>
            <Modal
                open={isOutgoingModalOpen && !person.is_outgoing}
                yesText={'Valider la sortie'}
                onValidate={() => {
                    document.getElementById('outgoingForm')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }}
                noText="Annuler"
                onClose={() => setIsOutgoingModalOpen(false)}
                setClose={() => setIsOutgoingModalOpen(false)}
            >
                <Formik
                    initialValues={{
                        outgoingReason: person.outgoingReason || ''
                    }}
                    enableReinitialize={true}
                    onSubmit={async (values, { setSubmitting }) => {
                        handleUpdateOutgoing(values.outgoingReason, !person.is_outgoing);
                        setSubmitting(false);
                    }}
                >
                    {(props) => (
                        <form id="outgoingForm" onSubmit={props.handleSubmit} noValidate>
                            <div className="form">
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Raison de la sortie</label>
                                        <Datalist
                                            list="person_outgoing_reasons"
                                            name="outgoingReason"
                                            placeholder="Quelle est la raison du départ ?"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.outgoingReason}
                                        />
                                        {props.errors.outgoingReason && props.touched.outgoingReason && (
                                            <p className="error">{String(props.errors.outgoingReason)}</p>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="form-line">
                                    <div className="form-group">
                                        <label>Date de départ</label>
                                        <input
                                            type="date"
                                            name="outgoingAt"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.outgoingAt}
                                        />
                                        {props.errors.outgoingReason && props.touched.outgoingReason && (
                                            <p className="error">{String(props.errors.outgoingReason)}</p>
                                        )}
                                    </div>
                                </div> */}
                            </div>
                        </form>
                    )}
                </Formik>
            </Modal>
            <Modal
                open={isOutgoingModalOpen && person.is_outgoing}
                yesText={'Oui'}
                title={'Réaffecter la personne au dispositif ?'}
                onValidate={() => {
                    document.getElementById('outgoingForm')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }}
                noText="Non"
                onClose={() => setIsOutgoingModalOpen(false)}
                setClose={() => setIsOutgoingModalOpen(false)}
            >
                <Formik
                    initialValues={{
                        outgoingReason: person.outgoingReason || ''
                    }}
                    enableReinitialize={true}
                    onSubmit={async (values, { setSubmitting }) => {
                        handleUpdateOutgoing(values.outgoingReason, false);
                        setSubmitting(false);
                    }}
                >
                    {(props) => <form id="outgoingForm" onSubmit={props.handleSubmit} noValidate></form>}
                </Formik>
            </Modal>
        </>
    );
}
